import { Divider, Spinner, useToast } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import useTable from '../../../../../hooks/useTable';
import { api } from '../../../../../services/api';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { PaginateDot } from './PaginateDot';

const TableLeads = ({ rowsPerPage, visualization, header, data }: any) => {
  const initialState = [
    {
      ID_MDM__c: '-',
      NOME__c: '-',
      segmento: '-',
      Campanha__c: '-',
      LOGIN__c: '-'
    }
  ];
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [leads, setLeads] = useState(data || initialState);

  const toast = useToast();

  const { slice, range } = useTable(leads, page, rowsPerPage);
  return (
    <>
      <div className="tw-px-10 tw-w-[100%] tw-text-[3vh] tw-font-bold tw-mt-[1rem]">
        <p>{header}</p>
      </div>
      <Divider orientation="horizontal" my="0.8rem" borderColor={'#CDCDCD'} />
      <div className="tw-w-[100%] tw-px-10 tw-text-[#001E64]">
        {!loading ? (
          <table className="tw-w-[100%] tw-border-separate [border-spacing:0_0.75rem]">
            <thead>
              <tr className="tw-text-left">
                <th className="tw-pl-[2vw]">ID_MDM</th>
                <th>Nome</th>
                <th>Segmento</th>
                <th>Campanha</th>
                <th>Vendedor</th>
              </tr>
            </thead>
            <tbody>
              {slice.map((el: any, index: any) => (
                <tr
                  key={index}
                  className={`${
                    +index % 2 > 0 ? 'tw-bg-[#F4F4F4]' : 'tw-bg-[#E9EEF6]'
                  } tw-rounded-2xl tw-h-[6vh]`}
                >
                  <td className="tw-border-l-[0.3rem] tw-border-solid tw-border-[#FF5000] tw-rounded-[0.4rem_0_0_0.4rem] tw-pl-[2vw]">
                    {el.ID_MDM__c || '-'}
                  </td>
                  <td>{el.NOME__c || '-'}</td>
                  <td>{el.segmento || '-'}</td>
                  <td>{el.Campanha__c || '-'}</td>
                  <td>{el.LOGIN__c || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <Spinner />
        )}
      </div>
      <div className="tw-px-10 tw-flex tw-justify-end tw-w-[100%] tw-py-8">
        <PaginateDot
          currentPage={page}
          lastPage={range}
          maxLength={5}
          setCurrentPage={setPage}
          totalData={leads}
        />
      </div>
    </>
  );
};

export default TableLeads;
